import { AlertCircle, Shield } from "lucide-react";
import { Checkbox } from "@/components/ui/checkbox";

export const NDABanner = ({ agreed, onAgreeChange, className = "" }) => {
  return (
    <div className={`bg-gradient-to-r from-amber-50 to-orange-50 border-2 border-amber-400 rounded-2xl p-6 shadow-lg ${className}`}>
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <Shield className="w-8 h-8 text-amber-600" />
        </div>
        <div className="flex-1">
          <div className="flex items-center gap-2 mb-3">
            <AlertCircle className="w-5 h-5 text-amber-600" />
            <h3 className="font-bold text-lg text-amber-900">CONFIDENTIALITY & NON-DISCLOSURE AGREEMENT</h3>
          </div>
          <p className="text-sm text-amber-900 mb-4 leading-relaxed">
            <strong>NOTICE:</strong> By accessing this portal and submitting a prize claim, you agree to maintain strict confidentiality regarding your claim, prize amount, and all related information. You acknowledge that disclosure of any confidential information to unauthorized parties may result in claim forfeiture and legal action. All information provided will be handled in accordance with applicable privacy laws and lottery regulations. This claim process and all related communications are confidential and proprietary.
          </p>
          <div className="flex items-start gap-3 bg-white/60 p-3 rounded-lg">
            <Checkbox
              id="nda-agreement"
              data-testid="nda-checkbox"
              checked={agreed}
              onCheckedChange={onAgreeChange}
              className="mt-1"
            />
            <label
              htmlFor="nda-agreement"
              className="text-sm font-semibold text-amber-900 cursor-pointer select-none"
            >
              I have read and agree to the Confidentiality & Non-Disclosure terms. I understand that all claim information must remain confidential.
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};
